function SectionFaqGeneral() {
    return (
        <>
            <div className="tw-faq-section">
                <div className="accordion tw-faq" id="sf-faq-accordion">
                    {/*One*/}
                    <div className="accordion-item">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" aria-expanded="true" data-bs-target="#FAQ1">
                            Where is my job posting advertised?
                        </button>
                        <div id="FAQ1" className="accordion-collapse collapse show" data-bs-parent="#sf-faq-accordion">
                            <div className="accordion-body">
                                Your job listing is advertised instantly on our public jobs search feed, distributed to qualified candidates via email notifications, and highlighted across matched category pages.
                            </div>
                        </div>
                    </div>
                    {/*Two*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ2" aria-expanded="false">
                            What Makes Your Job Portal So Useful?
                        </button>
                        <div id="FAQ2" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion">
                            <div className="accordion-body">
                                We bridge the gap between recruiters and top-tier candidates by offering robust resume matching, real-time messaging, comprehensive tracking metrics, and verified candidate pools.
                            </div>
                        </div>
                    </div>
                    {/*Three*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ3" aria-expanded="false">
                            Reset Password With Phone Number?
                        </button>
                        <div id="FAQ3" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion">
                            <div className="accordion-body">
                                Yes, you can reset your password securely. Simply navigate to the login page, select the reset option, and enter your registered email address or phone number to receive a secure recovery code.
                            </div>
                        </div>
                    </div>
                    {/*Four*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ4" aria-expanded="false">
                            How do I redeem a coupon?
                        </button>
                        <div id="FAQ4" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion">
                            <div className="accordion-body">
                                You can redeem promotional coupons at the checkout screen when purchasing job posting packages or subscription plans inside the billing dashboard.
                            </div>
                        </div>
                    </div>
                    {/*Five*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ5" aria-expanded="false">
                            How long will it take to post my job?
                        </button>
                        <div id="FAQ5" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion">
                            <div className="accordion-body">
                                Once submitted, job postings are immediately draft-saved and usually reviewed and published by our quality control moderators within a few business hours.
                            </div>
                        </div>
                    </div>
                    {/*Six*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ6" aria-expanded="false">
                            What is your cancellation policy?
                        </button>
                        <div id="FAQ6" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion">
                            <div className="accordion-body">
                                You have absolute control. You can choose to archive, pause, or permanently delete any active or draft jobs directly from your employer management panel at any time.
                            </div>
                        </div>
                    </div>
                    {/*Seven*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ7" aria-expanded="false">
                            Where Can I Find Market Research Reports?
                        </button>
                        <div id="FAQ7" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion">
                            <div className="accordion-body">
                                Logged-in employers can access visual analytics, sector salary ranges, and regional candidate distribution reports directly within the built-in analytics dashboard.
                            </div>
                        </div>
                    </div>
                    {/*Eight*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ8" aria-expanded="false">
                            Do I need to know PHP to use TheJobs?
                        </button>
                        <div id="FAQ8" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion">
                            <div className="accordion-body">
                                Absolutely not! Our platform features a user-friendly drag-and-drop builder interface, allowing you to easily list positions and review candidates with zero coding required.
                            </div>
                        </div>
                    </div>
                    {/*Nine*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ9" aria-expanded="false">
                            How soon will I start receiving resumes?
                        </button>
                        <div id="FAQ9" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion">
                            <div className="accordion-body">
                                You will start receiving qualified candidate applications instantly as soon as jobseekers view your posting and submit their resumes online.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SectionFaqGeneral;
